/* Lenis smooth scroll — desktop only, mirroring the setup on
   wecanflyagency.com (duration 0.7, exponential ease). Loaded from jsDelivr
   with a pinned version; theirs uses @latest, which can change under you.

   Skipped below 990px, for prefers-reduced-motion, and inside the theme
   editor, where Shopify's own scrolling fights a hijacked scroller. */
(function () {
  var LENIS_URL = 'https://cdn.jsdelivr.net/npm/lenis@1.1.18/dist/lenis.min.js';

  if (window.innerWidth <= 989) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var script = document.createElement('script');
  script.src = LENIS_URL;
  script.defer = true;

  script.onload = function () {
    if (typeof Lenis === 'undefined') return;

    var lenis = new Lenis({
      duration: 0.7,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    window.lenis = lenis;
    // NOT a lenis-* name: Lenis rewrites the root className with
    // .replace(/lenis(-\w+)?/g, '') on every class update, which would strip
    // our own flag and switch native smooth scrolling back on mid-scroll.
    document.documentElement.classList.add('has-smooth-scroll');

    // In-page anchors must go through Lenis, or they jump while it animates.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      // Lenis ignores scroll-margin-top, so the sticky bar's height is taken
      // off the target position by hand — otherwise the section lands under it.
      var header = document.querySelector('.landing-header');
      var offset = header ? -(header.getBoundingClientRect().height + 16) : 0;
      lenis.scrollTo(target, { offset: offset });
    });

    window.addEventListener('load', function () { lenis.resize(); });

    // Debounced: splitting headings into characters fires hundreds of
    // mutations, and a resize on each one stutters the scroll.
    var resizeTimer = null;
    new MutationObserver(function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { lenis.resize(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  };

  script.onerror = function () {
    // CDN unreachable: native scrolling stays, nothing else to undo.
    document.documentElement.classList.remove('has-smooth-scroll');
  };

  document.head.appendChild(script);
})();
